import React from 'react';
import { Card, CardContent } from './ui/card';

export const ProductSkeleton = () => {
  return (
    <Card className="overflow-hidden rounded-2xl border-gray-100 animate-pulse">
      {/* Imagem Skeleton */}
      <div className="aspect-square bg-gray-200" />
      
      <CardContent className="p-4 space-y-2">
        {/* Badge */}
        <div className="h-5 w-20 bg-gray-200 rounded-full" />
        
        {/* Título */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-3/4" />
        </div>
        
        {/* Tamanho */}
        <div className="h-3 bg-gray-200 rounded w-16" />
        
        {/* Botões */}
        <div className="mt-3 flex flex-col sm:flex-row gap-2">
          <div className="h-9 bg-gray-200 rounded-full w-full sm:flex-1" />
          <div className="h-9 bg-gray-200 rounded-full w-full sm:flex-1" />
        </div>
      </CardContent>
    </Card>
  );
};

export const ProductGridSkeleton = ({ count = 8 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <ProductSkeleton key={i} />
      ))}
    </div>
  );
};